import { NavLink } from 'react-router-dom'
import texts from '../../texts'

type NavKey = 'home' | 'game' | 'clubs' | 'stats' | 'me'

const tabClass = (forced: boolean) => (({ isActive }: { isActive: boolean }) =>
  `grid gap-0.5 rounded-[10px] py-1.5 text-center text-[0.6rem] leading-tight no-underline ${
    forced || isActive ? 'text-gold' : 'text-text-2'
  }`)

interface BottomNavProps {
  /** Tvinger et faneblad til at fremstå som aktivt, fx "me" på en side uden egen rute (Pointsystem). */
  current?: NavKey
}

function BottomNav({ current }: BottomNavProps = {}) {
  return (
    <nav className="fixed bottom-0 left-1/2 z-10 grid w-full max-w-[430px] -translate-x-1/2 grid-cols-5 gap-1 border-t border-text-2/20 bg-felt/90 px-1 pb-[calc(8px+env(safe-area-inset-bottom,0px))] pt-1.5 backdrop-blur-md md:max-w-[560px] lg:max-w-[640px]">
      <NavLink to="/" end className={tabClass(current === 'home')}>
        <b className="text-[1.15rem] font-normal leading-none">⌂</b>
        {texts.nav.home}
      </NavLink>
      <NavLink to="/spil" className={tabClass(current === 'game')}>
        <b className="text-[1.15rem] font-normal leading-none">♠</b>
        {texts.nav.game}
      </NavLink>
      <NavLink to="/klubber" className={tabClass(current === 'clubs')}>
        <b className="text-[1.15rem] font-normal leading-none">♣</b>
        {texts.nav.clubs}
      </NavLink>
      <NavLink to="/stats" className={tabClass(current === 'stats')}>
        <b className="text-[1.15rem] font-normal leading-none">◔</b>
        {texts.nav.stats}
      </NavLink>
      <NavLink to="/me" className={tabClass(current === 'me')}>
        <b className="text-[1.15rem] font-normal leading-none">☺</b>
        {texts.nav.me}
      </NavLink>
    </nav>
  )
}

export default BottomNav
